module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/icon-prize-02-0d8afd290f6971da9554b12989a25df6.svg";